import { render, staticRenderFns } from "./purchaseDiscountsHistory.vue?vue&type=template&id=ed5ca89c"
import script from "./purchaseDiscountsHistory.vue?vue&type=script&lang=js"
export * from "./purchaseDiscountsHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports